import { UseProvidedAuthInterface } from "../../../../hooks";
import { Role, SchoolYear } from "../../../../models";
import {
  CommitteeTypeEnum,
  CommitteeEmployee,
  Committee,
} from "../../../../models/Committee";
import { CommitteeDecision, Request } from "../../../../models/Request";
import {
  ALLOWED_ROLES_BASE_FOR_EDITING_DECISION,
  ALLOWED_ROLES_INSTITUTION_FOR_EDITING_DECISION,
  ALLOWED_ROLES_COUNTY_FOR_EDITING_DECISION,
} from "../constants.table";
import {
  checkIsCommitteeInactive,
  hasAllowedRoleForEditing,
} from "./committee-operations.util";

export const getAllowedRolesForEditingDecision = (
  committeeType: CommitteeTypeEnum
): Role[] => {
  const allowedRoles = [...ALLOWED_ROLES_BASE_FOR_EDITING_DECISION];

  if (committeeType === CommitteeTypeEnum.Institution) {
    allowedRoles.push(...ALLOWED_ROLES_INSTITUTION_FOR_EDITING_DECISION);
  } else if (committeeType === CommitteeTypeEnum.County) {
    allowedRoles.push(...ALLOWED_ROLES_COUNTY_FOR_EDITING_DECISION);
  }

  return allowedRoles;
};

// Used to check the current active year, they can never edit something of previous years
export const checkSchoolYearValidity = (
  schoolYearId: Request["schoolYearId"],
  schoolYear?: SchoolYear
) => {
  return !!(schoolYearId && schoolYear?.id === schoolYearId);
};

export const checkIsCommitteeMemberOrPresident = (
  auth: UseProvidedAuthInterface,
  committeeId: number | undefined,
  _committeeEmployeeId: CommitteeDecision["committeeEmployeeId"] | undefined,
  onlyPresident?: boolean
) => {
  if (!committeeId) return false;

  return !!auth
    .getCommitteeMembershipByCommitteeId(committeeId)
    ?.some(
      ({ isPresident, committeeEmployeeId }) =>
        isPresident ||
        (onlyPresident ? false : committeeEmployeeId === _committeeEmployeeId)
    );
};

export const hasDecisionPermission = ({
  committeeType,
  auth,
  committeeEmployee,
  committees,
  onlyPresident,
}: {
  committeeType?: CommitteeTypeEnum;
  auth: UseProvidedAuthInterface;
  committeeEmployee: CommitteeEmployee | undefined;
  committees?: Committee[];
  onlyPresident?: boolean;
}) => {
  if (!committeeEmployee || !committeeType) return false;

  const isAllowedRole = hasAllowedRoleForEditing(committeeType, auth);

  const isCommitteeMemberOrPresident = checkIsCommitteeMemberOrPresident(
    auth,
    committeeEmployee.committeeId,
    committeeEmployee.id,
    onlyPresident
  );

  const isCommitteeInactive = committees
    ? checkIsCommitteeInactive(committees, committeeEmployee)
    : false;

  return (
    isAllowedRole || (isCommitteeMemberOrPresident && !isCommitteeInactive)
  );
};
